import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import moment from "moment";

class ConfirmDiffContent extends React.Component {
  render() {
    const { data, className, t } = this.props;

    return (
      <div className={`confirm-diff-content-container ${className || ""}`}>
        <div className="confirm-diff-content-container-date">
          <div className="confirm-diff-content-container-date-old">
            {t("common_date_now")}
          </div>
          <div className="confirm-diff-content-container-date-new">
            {moment(data.updateDate).format(t("common_date_after"))}
          </div>
        </div>
        <div className="confirm-diff-content-container-content">
          <div
            className="confirm-diff-content-container-content-old"
            dangerouslySetInnerHTML={{
              __html: data.contentText1,
            }}
          />
          <div
            className="confirm-diff-content-container-content-new"
            dangerouslySetInnerHTML={{
              __html: data.contentText2,
            }}
          />
        </div>
        <div className="confirm-diff-content-container-line">
          <div className="confirm-diff-content-container-line-old" />
          <div className="confirm-diff-content-container-line-new" />
        </div>
      </div>
    );
  }
}

ConfirmDiffContent.propTypes = {
  data: PropTypes.object,
};

export default withTranslation()(ConfirmDiffContent);
